import {ACCEPTED_TYPES_IN_MESSAGE_LIST} from '@/types/matrix';
import {MatrixClient, MatrixEvent} from 'matrix-js-sdk';

export const loadInitialEvents = async (
  client: MatrixClient,
  roomId: string,
  unreadEventsCount: number
): Promise<MatrixEvent[]> => {
  try {
    if (!client) {
      throw new Error('Matrix client is not initialized.');
    }

    const room = await client.getRoom(roomId);

    if (!room) {
      throw new Error(`Room with id ${roomId} does not exist.`);
    }

    const baseEventCount = 30;

    const totalEventsToLoad =
      unreadEventsCount > baseEventCount
        ? unreadEventsCount + 10
        : baseEventCount;

    const matrixEvents = await room.getLiveTimeline().getEvents();

    const filteredMatrixEvents = matrixEvents.filter((event) => {
      const effectiveEvent = event.getEffectiveEvent();
      return ACCEPTED_TYPES_IN_MESSAGE_LIST.includes(effectiveEvent.type);
    });

    if (
      matrixEvents.length < totalEventsToLoad ||
      filteredMatrixEvents.length < 2
    ) {
      const roomWithMoreEvents = await client.scrollback(
        room,
        totalEventsToLoad
      );

      const additionalEvents = await roomWithMoreEvents
        .getLiveTimeline()
        .getEvents();

      return additionalEvents;
    }

    return matrixEvents;
  } catch (error) {
    console.error('Error loading initial events:', error);
    throw error;
  }
};
